import type React from 'react';
import { sortBy } from 'lodash';

import type { AdminTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import LoadingAutocomplete from '../../shared/LoadingAutocomplete';

interface Props {
  orgs: AdminTypes.OrganizationDto[];
  loading: boolean;
  value: AdminTypes.OrganizationDto | null;
  onChange: (
    event: React.ChangeEvent<object>,
    value: AdminTypes.OrganizationDto | null,
  ) => void;
}

const OrgSelector = ({ orgs, loading, value, onChange }: Props) => (
  <LoadingAutocomplete
    label='Organization'
    loading={loading}
    size='small'
    id='org'
    options={sortBy(orgs, 'name')}
    value={value}
    getOptionLabel={(option) => `${option.displayName} (${option.id})`}
    isOptionEqualToValue={(o, v) => o.id === v.id}
    onChange={onChange}
    sx={{ maxWidth: 360 }}
  />
);

export default OrgSelector;
